import { Home, ShoppingBag, MapPin, Clock, RotateCcw } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";

const getNavItems = (isMember: boolean) => [
  { path: isMember ? "/membership/dashboard" : "/", icon: Home, label: "Home" },
  { path: isMember ? "/member/order/store-details" : "/schedule-pickup/store-details", icon: ShoppingBag, label: "Order" },
  { path: isMember ? "/member/stores" : "/store-selection", icon: MapPin, label: "Stores" },
  { path: isMember ? "/member/returns/store-details" : "/returns/store-details", icon: RotateCcw, label: "Returns" },
  { path: "/pickup-history", icon: Clock, label: "Track" },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const navItems = getNavItems(Boolean(user));

  // Only hide on admin pages
  if (location.pathname.startsWith("/admin")) return null;

  // Only show on mobile (CSS handles this, but also check Capacitor)
  return (
    <nav
      data-site-bottom-nav
      aria-label="Mobile navigation"
      className="safe-area-bottom fixed inset-x-0 bottom-0 z-[45] border-t border-gray-200 bg-white shadow-[0_-8px_24px_rgba(15,23,42,0.08)] [backface-visibility:hidden] [transform:translateZ(0)] md:hidden"
    >
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive =
            item.path === "/"
              ? location.pathname === "/"
              : item.path === "/member/stores"
                ? location.pathname === "/member/stores" || location.pathname === "/stores"
                : item.path === "/member/order/store-details"
                  ? location.pathname.startsWith("/member/order")
                  : item.path === "/member/returns/store-details"
                    ? location.pathname.startsWith("/member/returns")
                    : item.path === "/returns/store-details"
                      ? location.pathname.startsWith("/returns")
                  : location.pathname.startsWith(item.path);

          // Redirect to auth if not logged in for protected routes
          const handleTap = () => {
            if (
              !user &&
              ["/member/order/store-details", "/member/stores", "/member/returns/store-details", "/pickup-history"].includes(item.path)
            ) {
              navigate("/auth");
              return;
            }
            navigate(item.path);
          };

          return (
            <button
              key={item.path}
              onClick={handleTap}
              className={`flex flex-col items-center justify-center flex-1 py-1 transition-colors ${
                isActive
                  ? "text-orange-500"
                  : "text-gray-400 active:text-gray-600"
              }`}
            >
              <Icon className={`w-5 h-5 ${isActive ? "stroke-[2.5]" : ""}`} />
              <span className={`text-[10px] mt-0.5 ${isActive ? "font-semibold" : ""}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
